function Resume() {
    return (
        <section className="about">
            <div className="resume">
                <h2>
                    Resume
                </h2>
                <div>Download my <a href="assets/files/Resume-Mohammad-Rahman.pdf" style={{ color: '#845ec2' }} download>resume</a></div>
                <div>
                    <h3>Front-end Proficiencies</h3>
                    <ul>
                        <li>HTML</li>
                        <li>CSS</li>
                        <li>JavaScript</li>
                        <li>jQuery</li>
                        <li>Responsive Design</li>
                        <li>React</li>
                        <li>Bootstrap</li>
                    </ul>
                </div>
                <div>
                    <h3>Back-end Proficiencies</h3>
                    <ul>
                        <li>APIs</li>
                        <li>Node</li>
                        <li>Express</li>
                        <li>MySQL, Sequelize</li>
                        <li>MongoDB, Mongoose</li>
                        <li>REST</li>
                        <li>GraphQL</li>
                    </ul>
                </div>
            </div>
        </section>
    )
}

export default Resume